import Modal from 'react-modal';
import { useForm } from "react-hook-form";
import ITask from "../../../../../models/task";
import { authenticatedApi } from "../../../../../Api/api";
import { isMobile } from 'react-device-detect';


type TaskUpdateDto = {
  title: string;
  description: string;
  isDone: string;
};

export default function ModalUpdateTask({
  task,
  onSaved = () => Promise.resolve(),
  ...props
}: Omit<Modal.Props, 'isOpen'> & {
  task: ITask;
  onSaved: (task: ITask) => Promise<any>;
}) {

  const {
    register,
    handleSubmit,
  } = useForm<TaskUpdateDto>({
    defaultValues: {
      title: task.title,
      description: task.description,
      isDone: task.isDone ? "true" : "false",
    }
  });

  const onSubmit = async (data: TaskUpdateDto) => {
    authenticatedApi.patch('/tasks/' + task.id, {
      ...data,
      isDone: data.isDone === "true",
    }).then((response) => {
      onSaved(response.data);
    }).catch((error) => {
      console.log(error);
      alert(error.response?.data?.message || "Une erreur est survenue")
    });
  };

  return (
    <Modal
      {...props}
      isOpen={true}
      appElement={document.getElementById('root') as HTMLElement}
      style={{
        overlay: {
          zIndex: 100000,
        },
        content: {
          display: "flex",
          flexDirection: "column",
          ...(isMobile ? {inset: "0px"} : {}),
        }
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title">Modifier une tache</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.onRequestClose}></button>
      </div>

      <div className="modal-body" style={{flex :1}}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-6">

              <div className="mb-3">
                <label htmlFor="title" className="form-label">Titre</label>
                <input type="text" className="form-control" id="title" {...register("title", {
                  required: true
                })} />
              </div>

              <div className="mb-3">
                <label htmlFor="description" className="form-label">Description</label>
                <textarea rows={10} className="form-control" id="description" {...register("description", {
                  required: false
                })} />
              </div>

              <div className="mb-3">
                <label htmlFor="isDone" className="form-label">Terminé</label>
                <select className="form-control" id="isDone" {...register("isDone", {
                  required: true
                })}>
                  <option value="true">Oui</option>
                  <option value="false">Non</option>
                </select>
              </div>

            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <button type="submit" className="btn btn-primary">Enregistrer</button>
            </div>
          </div>
        </form>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={props.onRequestClose}>Fermer</button>
      </div>

    </Modal>
  )
}